import { render } from "./customChatlogHistory.vue?vue&type=template&id=339b1f9a&scoped=true"
import script from "./customChatlogHistory.vue?vue&type=script&lang=js"
export * from "./customChatlogHistory.vue?vue&type=script&lang=js"

import "./customChatlogHistory.vue?vue&type=style&index=0&id=339b1f9a&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339b1f9a"]])

export default __exports__